import { ChartBuilder } from 'Molecules/InsightsChart/chartBuilder';
import { ChartType } from '../chartTypes';
import { BaseInsightPayload } from '../InsightDataPayload';
import { InsightChartFactory } from '../insightChartFactory';
import { parseCapacityManagementAllocatedHoursPayload } from '../payloads/capacityManagementAllocatedHoursPayload';
import DefaultChartWithTrendSupport from 'Molecules/InsightsChart/DefaultChartWithTrendSupport';

export const buildCapacityManagementAllocatedHoursInsightFactory = (
  payload: BaseInsightPayload
): InsightChartFactory => {
  const parsedPayload = parseCapacityManagementAllocatedHoursPayload(payload);
  const aggregate = parsedPayload.data.attributes.aggregate;

  return (props) => {
    const chart = new ChartBuilder()
      .setChartType(ChartType.KPI)
      .setProps({
        chartData: {
          value: aggregate.total_allocated_hours.current ?? 0,
          trend: aggregate.total_allocated_hours.percentage_change ?? 0,
          trendIsPercent: true,
          description: props.name,
        },
      })
      .build();

    return DefaultChartWithTrendSupport({
      chartComponent: chart,
    });
  };
};
